<template>
    <div class="months">
        <div
            v-for="i in monthsToShow + 1"
            class="column"
            :key="i"
        >
            <div class="label">
                {{ monthLabel(i - 1) }}
                <template v-if="i === 1">{{ startOfInterval.year() }}</template>
                <template v-if="i === monthsToShow + 1">{{ endOfInterval.year() }}</template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TimelineAxisDesktop',
    props: {
        startOfInterval: {
            type: Object,
            required: true,
        },
        monthsToShow: {
            type: Number,
            required: true,
        },
    },
    data: () => ({
        months: [
            'Январь',
            'Февраль',
            'Март',
            'Апрель',
            'Май',
            'Июнь',
            'Июль',
            'Август',
            'Сентябрь',
            'Октябрь',
            'Ноябрь',
            'Декабрь',
        ],
    }),
    computed: {
        endOfInterval() {
            return this.startOfInterval
                .clone()
                .add(this.monthsToShow + 1, 'months');
        },
        monthLabel() {
            return (i) => {
                return this.months[(this.startOfInterval.month() + i) % 12];
            };
        },
    },
};
</script>

<style lang="scss" scoped>
    @import '~@/styles/rem';

    .months {
        display: flex;
        width: 100%;
        justify-content: space-between;

        padding: 0 32px;

        .column {
            border: 0;
            flex: 0;
            width: 1px;
            display: flex;
            justify-content: center;
            align-items: flex-end;

            .label {
                height: 32px;
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
                font-size: 12px;
                line-height: 16px;
                color: #98A0A9;
            }
        }

        min-height: 32px;
    }
</style>
